<template>
  <div class="footer">
    <div class="f-top">
      <div class="container">
        <div class="bd">
          <div class="row">
            <div class="foot1 col-lg-3 col-md-3">
              <span class="ff1">联系方式</span><br />
              电话：<span class="ff2">0371-65555168</span><br />
              <!-- 电话：<span class="ff2">0371-68886168</span><br /> -->
              手机：<span class="ff2">19937116888</span><br />
              手机：<span class="ff2">15837161168</span><br />

              地址：武陟县詹店新区昌平路3号<br />
              邮箱：<a href="mailto:861333640@qq.com">861333640@qq.com</a>
            </div>
            <div class="foot2 col-lg-2 col-md-2 hidden-xs hidden-sm">
              <span>产品展示</span><br />
              <a href="/commonp?type=13">布电线</a><br />
              <a href="/commonp?type=14">电力电缆</a><br />
              <a href="/commonp?type=16">控制电缆</a><br />
              <a href="/commonp?type=17">低烟无卤电缆</a><br />
            </div>
            <div class="foot2 col-lg-2 col-md-2 hidden-xs hidden-sm">
              <ul>
                <span>关于我们</span
                ><br />
                <a href="/about">公司简介</a
                ><br />
                <a href="/honerp">资质荣誉</a
                ><br />
                <a href="/message">在线留言</a
                ><br />
              </ul>
            </div>
            <div class="foot4 col-lg-3 col-md-3">
              <img
                src="./../assets/images/749da61cb19049b7313a5f0abd7e2f7f.webp"
                alt="河南一六八线缆有限公司"
              /><br />扫一扫，关注我们
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="f-bot">
      <div class="container">
        <ul>
          Copyright　<span style="font-family: Arial">©</span
          >　2024　河南一六八线缆有限公司　备案号：<a
            href="https://beian.miit.gov.cn"
            target="_blank"
            >豫ICP备2024082131号-1</a
          >　地址：武陟县詹店新区昌平路3号　
          <br />
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
.row {
  display: flex;
  justify-content: space-between;
  text-align: left;
}
.foot3 ul {
  width: 50%;
}
.footer {
  background-color: rgba(0, 0, 0, 1);
}
</style>
